import { PageLevelMessage } from '@americanexpress/dls-react';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import * as styles from './OfflineWarning.scss';

class OfflineWarning extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hidden: false,
      fetchIconFont: false,
    };
  }

  componentDidMount() {
    window.addEventListener('online', this.hideWarning);
    window.addEventListener('offline', this.showWarning);
    this.deferredRenderOfflineFontFetcher();
  }

  componentWillUnmount() {
    window.removeEventListener('online', this.hideWarning);
    window.removeEventListener('offline', this.showWarning);
  }

  deferredRenderOfflineFontFetcher = () => {
    const callback = () => this.setState({ fetchIconFont: true });

    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(callback);
    } else {
      setTimeout(callback, 10e6);
    }
  }

  showWarning = () => this.setState({ hidden: false });

  hideWarning = () => this.setState({ hidden: true });

  returnToHide = (event) => {
    if (event.keyCode === 13) {
      this.hideWarning();
    }
  }

  render() {
    const offline = global.BROWSER && navigator.onLine === false;
    const { hidden, fetchIconFont } = this.state;

    if (!offline || hidden) {
      return fetchIconFont
        ? <div className={`${styles.offlineFontFetcher}`} />
        : null;
    }

    return (
      <aside className={styles.offlineWarning}>
        <PageLevelMessage
          type="warning"
          dismissible="true"
        >
          <FormattedMessage
            id="offlineWarning"
            defaultMessage="You are not connected to the internet. Some experiences may not work as expected."
          />
        </PageLevelMessage>
        <button
          type="button"
          onClick={this.hideWarning}
          onKeyUp={this.returnToHide}
          aria-label="Close"
        />
      </aside>
    );
  }
}

export default OfflineWarning;
